export enum GLOBAL_STATE_CATEGORIES {
  ACCOUNT = 'account',
  ACTIVATION = 'activation',
  PORTING = 'porting',
  PLAN = 'plan',
  SOCIAL = 'social_tariff',
  PLAN_CHANGE = 'plan_change',
  MANUAL_RENEWAL = 'manual_renewal',
  FAMILY_PLAN = 'family_plan',
  REPLACEMENT_SIM_REQUEST = 'replacement_sim_request',
}

export enum GroupV1PortInStatuses {
  PORT_REQUESTED = 'port_requested',
  PORT_SUCCESS = 'port_success',
  PORT_FAILURE = 'port_failure',
  PORT_CANCELLED = 'port_cancelled', // not for ULFP
  PORT_SKIPPED = 'port_skipped', // is absent on BE
  PORT_EXPIRED = 'port_expired', // is absent on BE
  MAYBE_PORT_SKIPPED = 'maybe_port_skipped', // is absent on BE(confirmed by Oleksii Bochurkin)
  MAYBE_PORT_AFTER_ORDER = 'maybe_port_after_order', // rare but possible
}

export enum ACTIVATION_STATUSES {
  AWAITING_NUMBER = 'awaiting_number',
  AWAITING_ORDER = 'awaiting_order',
  PENDING = 'pending',
  REQUESTED = 'requested',
  SUCCESS = 'success',
  AWAITING_UNDELIVERED_SIM = 'awaiting_undelivered_sim',
  AWAITING_NEW_SIM = 'awaiting_new_sim',
  NEW_SIM_ACTIVATION_REQUESTED = 'new_sim_activation_requested',
}

export enum PLAN_STATUSES {
  TERMINATED = 'terminated',
  PAYMENT_REQUIRED = 'payment-required',
}

export enum GLOBAL_STATE_TYPES {
  ACTIVE = 'active',
  AWAITING_NEW_SIM = 'awaiting_new_sim',
  AWAITING_NUMBER = 'awaiting_number',
  AWAITING_ORDER = 'awaiting_order',
  AWAITING_UNDELIVERED_SIM = 'awaiting_undelivered_sim',
  CAN_RENEW = 'can_renew',
  EXPIRED = 'expired',
  NEW_SIM_ACTIVATION_REQUESTED = 'new_sim_activation_requested',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  NEW_SIM_REQUESTED = 'awaiting_new_sim',
  PAUSED = 'paused',
  PAYMENT_REQUIRED = 'payment-required',
  PENDING = 'pending',
  REQUESTED = 'requested',
  SUCCESS = 'success',
  SUSPENDED = 'suspended',
  TERMINATED = 'terminated',
  FAILURE = 'failure',
  FAILED = 'failed',
  ACTIVATION_REQUESTED = 'activation_requested',
  AWAITING_ACTIVATION = 'activation_pending',
  ACTIVATION_FAILED = 'activation_failed',
  ACTIVATION_COMPLETED = 'activation_completed',
  SIM_REQUESTED = 'sim_requested',
  UNSUSPENDED = 'unsuspended',
  SIM_REQUESTED_PROCESSED = 'sim_requested_processed',
  SUSPENSION_REQUESTED = 'suspension_requested',
  SIM_REQUEST_FAILURE = 'sim_request_failure',
  SUSPENSION_FAILURE = 'suspension_failure',
}
